
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const STORAGE_GROUPS = {
  requestOrderPurchaseOrder: [
    "requestOrderFilter",
    "requestOrderPaging",
    "purchaseOrderFilter",
    "purchaseOrderPaging",
  ],
  import: ["importFilter", "importPaging"],
  importTransfer: ["importTransferFilter", "importTransferPaging"],
  export: ["exportFilter", "exportPaging"],
  exportTransfer: ["exportTransferFilter", "exportTransferPaging"],
  check: ["checkFilter", "checkPaging"],
};

export const clearFilterStorage = () => {
  Object.values(STORAGE_GROUPS)
    .flat()
    .forEach((key) => sessionStorage.removeItem(key));
};

const isPathOrChild = (pathname, basePath) =>
  pathname === basePath || pathname.startsWith(`${basePath}/`);

const DETAIL_PATHS = [
  "/app/manager/import/detail",
  "/app/manager/import/transfer",
  "/app/manager/transfer/detail",
  "/app/manager/transfer/transfer-detail",
];

const isDetailPath = (pathname) =>
  DETAIL_PATHS.some((path) => isPathOrChild(pathname, path));

const getStorageGroup = (location) => {
  const { pathname, search, state } = location;
  const params = new URLSearchParams(search);
  const tab = params.get("tab");

  // Detail có thể được mở từ RO, PO hoặc các danh sách nhập/xuất.
  if (isDetailPath(pathname)) {
    const sourceGroup = state?.storageGroup;

    if (sourceGroup && STORAGE_GROUPS[sourceGroup]) {
      return sourceGroup;
    }

    if (isPathOrChild(pathname, "/app/manager/import/transfer")) {
      return "importTransfer";
    }

    if (isPathOrChild(pathname, "/app/manager/import/detail")) {
      return "import";
    }

    if (
      isPathOrChild(pathname, "/app/manager/transfer/transfer-detail")
    ) {
      return "exportTransfer";
    }

    if (isPathOrChild(pathname, "/app/manager/transfer/detail")) {
      return "export";
    }
  }

  // Danh sách và detail RO / PO
  if (
    isPathOrChild(pathname, "/app/manager/request-order") ||
    isPathOrChild(pathname, "/app/manager/purchase-order")
  ) {
    return "requestOrderPurchaseOrder";
  }

  // Danh sách nhập kho
  if (pathname === "/app/manager/import") {
    return tab === "transfer" ? "importTransfer" : "import";
  }

  // Danh sách xuất kho
  if (pathname === "/app/manager/transfer") {
    return tab === "transfer" ? "exportTransfer" : "export";
  }

  // Kiểm kho
  if (isPathOrChild(pathname, "/app/manager/check")) {
    return "check";
  }

  return null;
};

const NavigationStorageManager = () => {
  const location = useLocation();
  const previousGroup = useRef(getStorageGroup(location));

  useEffect(() => {
    const currentGroup = getStorageGroup(location);
    const previous = previousGroup.current;

    if (previous && previous !== currentGroup) {
      (STORAGE_GROUPS[previous] || []).forEach((key) => {
        sessionStorage.removeItem(key);
      });
    }

    previousGroup.current = currentGroup;
  }, [location.pathname, location.search, location.state]);

  return null;
};

export default NavigationStorageManager;
